// extracted by css-extract-rspack-plugin
export default {"ShieldIcon":"BranchProtectionShield-module__ShieldIcon__zVbCj"};